/** The two fields any surface may hold a person's role in. */
export interface ProspectJobTitleSource {
	title?: string | null;
	jobTitleToSeniority?: { jobTitle?: string | null } | null;
}

/**
 * The one job title to render for a prospect, everywhere.
 *
 * `prospect.title` is the role read straight off the person's current LinkedIn position;
 * `jobTitleToSeniority.jobTitle` is a normalized lookup written alongside it. Surfaces used to
 * pick between them ad hoc — the lead list and the tracker's employee rows showed the normalized
 * one, every detail view showed `title` — so once the two drifted apart the same person appeared
 * to hold a different role depending on where you looked (PREC-3804). The raw current role wins;
 * the lookup only fills in when it is missing.
 */
export function prospectJobTitle(prospect?: ProspectJobTitleSource | null): string {
	return prospect?.title || prospect?.jobTitleToSeniority?.jobTitle || "";
}
